module.exports = __webpack_public_path__ + "img/usrename.fbb11643.png";